import { KANBANS_SET, KANBAN_ADDED, KANBAN_EDITED, KANBAN_DELETED } from 'src/app/redux/redux-types';
import { reduxKanbanTypes } from 'src/types';

export const kanbanDefaultState: reduxKanbanTypes.StateType = {
  kanbanList: [],
};

export const kanbanReducer = (
  state = kanbanDefaultState,
  kanban: reduxKanbanTypes.ActionType,
): reduxKanbanTypes.StateType => {
  switch (kanban.type) {
    case KANBANS_SET:
      return {
        ...state,
        kanbanList: kanban.payload,
      };
    case KANBAN_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.kanbanList.some((item) => item.id === kanban.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        kanbanList: [kanban.payload, ...state.kanbanList],
      };
    case KANBAN_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.kanbanList.findIndex((obj) => obj.id === kanban.payload.id);
      return {
        ...state,
        kanbanList: [
          ...state.kanbanList.slice(0, updateIndex),
          kanban.payload,
          ...state.kanbanList.slice(updateIndex + 1),
        ],
      };
    case KANBAN_DELETED:
      return {
        ...state,
        kanbanList: state.kanbanList.filter((o) => o.id !== kanban.payload),
      };
    default:
      return state;
  }
};
